(function(angular){
	'use strict';

	angular
		.module('contactModule')
		.controller('ContactController', [
			'contactFactory',
			'vcRecaptchaService',
			'$timeout',
			ContactControllerFunction
		]);

	function ContactControllerFunction(
		contactFactory,
		vcRecaptchaService,
		$timeout
	) {
		var contact = this;
		var widgetId;

		contact.sendMessage = function() {
			var data = {
				name: contact.name,
				email: contact.email,
				message: contact.message,
				captchaAnswer: contact.recaptchaResponse
			};

			contactFactory.sendMessage(data)
				.then(function(response) {
					contact.messageSent = true;
				})
				.catch(function(response) {
					contact.formSubmitted = false;
				});
		};

		contact.resetRecaptcha = function(){
			vcRecaptchaService.reload(widgetId);
			contact.formSubmitted = false;
		};

		contact.setWidgetId = function(id){
			widgetId = id;
		};

		contact.initRecaptcha = function(){
			vcRecaptchaService.execute(widgetId);
		};

		contact.successfulRecaptcha = function(){
			contact.recaptchaResponse = vcRecaptchaService.getResponse(widgetId);

			$timeout(function(){
				contact.sendMessage();
			});
		};

	}
})(window.angular);